import React, { createRef } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { matchUrlPathname } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { useRouteByName } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@atlassian/jira-software-devops-fedramp-utils/src/index.tsx';
import { messages } from './messages.tsx';

type ToolchainMenuItemProps = {
	projectId: number;
	projectKey: string;
};

export const ToolchainMenuItem = ({ projectId, projectKey }: ToolchainMenuItemProps) => {
	const { formatMessage } = useIntl();

	const toolchainRoute = useRouteByName('project-settings-software-toolchain-company-managed');
	// The route definition will be null when this component is rendered outside
	// of the SPA (e.g. the `Development tools` tab in Classic projects)

	// Don't render MenuItem if FedRAMP enabled
	if (isDevopsFeatureDisabledInFedRamp()) {
		return null;
	}

	return toolchainRoute ? (
		<MenuItem
			analytics={{ itemId: 'toolchain' }}
			ref={createRef()}
			data-test-id="navigation-apps-sidebar-software-classic.ui.menu.settings.toolchain-menu-item.menu-item-toolchain"
			selectedOn={['project-settings-software-toolchain-company-managed']}
			to={toolchainRoute}
			params={{ projectKey }}
			query={{ projectId: String(projectId) }}
			prefetch="hover"
		>
			{formatMessage(messages.toolchain)}
		</MenuItem>
	) : (
		<MenuItem
			analytics={{ itemId: 'toolchain' }}
			selectedOn={matchUrlPathname()}
			href={`/jira/software/c/projects/${projectKey}/settings/toolchain?projectId=${projectId}`}
			ref={createRef()}
			data-test-id="navigation-apps-sidebar-software-classic.ui.menu.settings.toolchain-menu-item.menu-item-toolchain"
		>
			{formatMessage(messages.toolchain)}
		</MenuItem>
	);
};
